import React from 'react';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';

import LoginScreen from './screens/LoginScreen'
import AdminScreen from './screens/AdminScreen';
import StatusScreen from './screens/StatusForbidden';

const App = () => (
  <Router>
    <Switch>
      <Route exact path="/login" component={LoginScreen}/>
      <Route exact path="/acesso-negado" component={StatusScreen}/>
      <Route path="/" component={AdminScreen}/>
    </Switch>
  </Router>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.js